'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MERGE_STATE_TYPE = exports.MERGE_STATE_TYPE = '@@WITH_REDUX_MERGE_STATE';
var SET_STATE_TYPE = exports.SET_STATE_TYPE = '@@WITH_REDUX_SET_STATE';